import React, { useEffect, useState } from "react";
import AdminNavbar from "../Component/AdminNavbar";
import "./AdminDashboard.css";
export const AdminDashboard = () => {
    const [orderCount, setOrderCount] = useState(0);
    const [userCount, setUserCount] = useState(0);
    const [revenue, setRevenue] = useState(0);
    const [productCount, setProductCount] = useState(0);
    useEffect(() => {

        const token = sessionStorage.getItem("token");

        fetch(`${process.env.REACT_APP_API_URL}/order/count`, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
            .then((res) => res.text())
            .then((data) => {
                setOrderCount(data);
            });
        fetch(`${process.env.REACT_APP_API_URL}/auth/count`)
            .then((res) => res.text())
            .then((data) => {
                setUserCount(data);
            });
        fetch(`${process.env.REACT_APP_API_URL}/order/revenue`, {
            headers: {
                Authorization: "Bearer " + token
            }
        })
            .then((res) => res.text())
            .then((data) => {
                setRevenue(data);
            });
        fetch(`${process.env.REACT_APP_API_URL}/product/count`)
            .then((res) => res.text())
            .then((data) => {
                setProductCount(data);
            });
    }, []);
    return (
        <div className="container mt-4">

            <AdminNavbar />



            <div className="admin-container">

                    <h2 className="dashboard-title">
                        Admin Dashboard
                    </h2>

                    <div className="row g-4">

                        <div className="col-md-3">
                            <div className="dashboard-card orders-card">
                                <div className="card-icon">📦</div>
                                <div className="card-number">{orderCount}</div>
                                <div className="card-title">Total Orders</div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="dashboard-card products-card">
                                <div className="card-icon">🥬</div>
                                <div className="card-number">{productCount}</div>
                                <div className="card-title">Products</div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="dashboard-card users-card">
                                <div className="card-icon">👥</div>
                                <div className="card-number">{userCount}</div>
                                <div className="card-title">Users</div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="dashboard-card revenue-card">
                                <div className="card-icon">💰</div>
                                <div className="card-number">₹{revenue}</div>
                                <div className="card-title">Revenue</div>
                            </div>
                        </div>

                    </div>

                    <div className="row mt-5">

                        <div className="col-md-8">
                            <div className="card shadow border-0 rounded-4 p-4">
                                <h4>Store Overview</h4>
                                <p className="text-muted">
                                    Welcome to Organica Admin Dashboard.
                                    Manage products, monitor orders, track revenue,
                                    and control user activity from one place.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card shadow border-0 rounded-4 p-4">
                                <h5>Quick Stats</h5>
                                <hr />
                                <p>📦 Orders: {orderCount}</p>
                                <p>🥬 Products: {productCount}</p>
                                <p>👥 Users: {userCount}</p>
                                <p>💰 Revenue: ₹{revenue}</p>
                            </div>
                        </div>

                    </div>

                </div>

        </div>
    );
};